import ShowDetailView from './ShowDetailView';
export default ShowDetailView;